export default __webpack_public_path__ + "img/31f3d9cb815422614aef2a7395f3e13f.jpg";